import React from 'react';
import Bio from './Components/Bio/Bio';
import Blog from './Components/Blog/Blog';
import Home from './Components/Home/Home';
import Footer from './Components/Footer/Footer';
import Events from './Components/Events/Events';
import Me from './Components/Me/Me';
import Mp4s from './Components/Mp4s/Mp4s';
import Nav from './Components/Nav/Nav';
import Jpgs from './Components/Jpgs/Jpgs';
import Sales from './Components/Sales/sales';
import Production from './Components/Production/Production';
import Web from './Components/Web/Web'
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import styled from 'styled-components'


function App() {
  return (
    <>
    <Router>
    <AppStyle>
      <Nav/>
      <Routes>
        <Route exact path='/' element={<Home/>}></Route>
        <Route exact path='/Bio' element={<Bio/>}></Route>
        <Route exact path='/Blog' element={<Blog/>}></Route>
        <Route exact path='/Events' element={<Events/>}></Route>
        <Route exact path='/Home' element={<Home/>}></Route>
        <Route exact path='/Sales' element={<Sales/>}></Route>
        <Route exact path='/Production' element={<Production/>}></Route>
        <Route exact path='/Jpgs' element={<Jpgs/>}></Route>
        <Route exact path='/Me' element={<Me/>}></Route>
        <Route exact path='/Mp4s' element={<Mp4s/>}></Route>
        <Route exact path='/Web' element={<Web/>}></Route>
      </Routes>
    <Footer/>
    </AppStyle>
    </Router>
</>
  );
}

export default App;

const AppStyle = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  height:100vh;
`
